import { setRates, setSymbols } from "../reducers/currencyReducer";

export const fetchCurrencies = () => async (dispatch) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/currencies?populate=*`);
        const json = await res.json();

        const ratesObj = {};
        const symbolsObj = {};

        if (json.data && Array.isArray(json.data)) {
            json.data.forEach((item) => {
                const { code, rate, symbol } = item;
                ratesObj[code] = rate;
                symbolsObj[code] = symbol;
            });

            dispatch(setRates(ratesObj));
            dispatch(setSymbols(symbolsObj));
        } else {
            console.error("Currency structure from API not recognized:", json);
        }
    } catch (error) {
        console.error("Failed to fetch currency rates:", error);
    }
};
